<template>
<div class="chapter">
<div class="inner_page">
<p class="nonindent01">Give me your tired, your poor,</p>
<p class="nonindent22">Your huddled masses yearning to breathe free,</p>
<p class="nonindent22">The wretched refuse of your teeming shore.</p>
<p class="nonindent22">Send those, the homeless, tempest-tost to me.</p>
<p class="nonindent22">I lift my lamp beside the golden door.</p>
<p class="right"><span class="smallcaps">INSCRIPTION BY</span> E<span class="smallcaps">MMA</span> L<span class="smallcaps">AZARUS</span></p>
<p class="right">Statue of Liberty, New York Harbor</p>
<p class="nonindent01">Yet there comes a time for forgetting,</p>
<p class="indent11">for who could live and not forget?</p>
<p class="nonindent22">Now and then, however, there must also</p>
<p class="indent11">be one who remembers.</p>
<p class="right">A<span class="smallcaps">LBRECHT</span> G<span class="smallcaps">OES,</span></p>
<p class="right">Das Brandopfer</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm01.vue?1257e40c